var map = {
  "./AttachmentTypeIcon.jsx": "2457",
  "./BellIcon.jsx": "58909",
  "./BroomIcon.jsx": "38273",
  "./CalendarIcon.jsx": "7716",
  "./CategoryIcon.jsx": "78818",
  "./CheckmarkCircleIcon.jsx": "58481",
  "./ChevronDown.jsx": "9504",
  "./ChevronUp.jsx": "2687",
  "./CloseSidebarIcon.jsx": "96138",
  "./DragGripHandleIcon.jsx": "11426",
  "./DragHandle.jsx": "80885",
  "./DrawerIcon.jsx": "68473",
  "./EllipsisIcon.jsx": "37435",
  "./FlagIcon.jsx": "40336",
  "./FormIcon.jsx": "87060",
  "./FormLightIcon.jsx": "33912",
  "./IconContainer.jsx": "61133",
  "./IndicatorIcon.jsx": "62005",
  "./LightXIcon.jsx": "30238",
  "./LockIcon.jsx": "49599",
  "./OpenSidebarIcon.jsx": "72118",
  "./PHPLogo.jsx": "56832",
  "./PencilIcon.jsx": "62649",
  "./ProfileIcon.jsx": "44297",
  "./RotateIcon.jsx": "44852",
  "./SearchIcon.jsx": "32166",
  "./SingleUserIcon.jsx": "30327",
  "./TaskFormsIcon.jsx": "32918",
  "./TaskGeneralIcon.jsx": "73859",
  "./TaskSubformIcon.jsx": "33055",
  "./TrashCanIcon.jsx": "86538",
  "./TwoPersonGroupIcon.jsx": "75340",
  "./WorkflowActionAddDepartmentIcon.jsx": "32866",
  "./WorkflowActionAddMembersIcon.jsx": "81185",
  "./WorkflowActionChangeStatusIcon.jsx": "64409",
  "./WorkflowActionRemoveAllMembersIcon.jsx": "46021",
  "./WorkflowActionSendNotificationIcon.jsx": "81160",
  "./WorkflowActionTaskCreateIcon.jsx": "12504",
  "./XIcon.jsx": "20370"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 15044;
